export { default as SelectableMultiplePeople } from "./SelectableMultiplePeople";
export { default as SelectableSinglePeople } from "./SelectableSinglePeople";
